export default __webpack_public_path__ + "static/media/solar-bg.39c940c7.png";